// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { Row, Column } from 'react-foundation';
import { breakup } from '@break';
import Social from './social';
import Legal from './legal';
import Content from './content';

// Styles
// ------
const Jacket = styled.footer`
    position: relative;
    width: 100%;
    margin-bottom: 6rem;

    ${breakup.large`
        margin-bottom: ${props => props.theme.padS};
    `}
`;

// Component
// ------
export default class Footer extends React.PureComponent {
    render() {
        return (
            <Jacket className="wow fadeIn">
                <Row isExpanded>
                    {/* Legal & Copyright */}
                    <Column small={12} medium={10} pushOnMedium={1} large={5} pushOnLarge={1}>
                        <Content />
                    </Column>

                    {/* Social Links */}
                    <Column small={4} medium={5} pushOnMedium={1} large={2} pushOnLarge={2}>
                        <Social
                            facebook={this.props.facebook}
                            twitter={this.props.twitter}
                            linkedin={this.props.linkedin}
                        />
                    </Column>

                    {/* Legal Links */}
                    <Column small={4} pullOnSmall={1} large={2} pullOnLarge={1}>
                        <Legal
                            privacyPolicy={this.props.privacyPolicy}
                            reviewsLink={this.props.reviewsLink}
                        />
                    </Column>
                </Row>
            </Jacket>
        );
    }
}